<template>
    
    <!-- Encabezado de la Aplicación -->
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Ajustes
        </div>
        <div class="right">
            <!-- <router-link :to="{ name: 'notifications' }" class="headerButton">
                <ion-icon class="icon" name="notifications-outline"></ion-icon>
                <span class="badge badge-danger">4</span>
            </router-link> -->
        </div>
    </div>
    <!-- * Encabezado de la Aplicación -->

    <!-- Cápsula de la Aplicación -->
    <div id="appCapsule">

        <!-- <div class="section mt-3 text-center">
            <div class="avatar-section">
                <a href="#">
                    <img src="@/assets/img/sample/avatar/avatar1.jpg" alt="avatar" class="imaged w100 rounded">
                    <span class="button">
                        <ion-icon name="camera-outline"></ion-icon>
                    </span>
                </a>
            </div>
        </div> -->

        <div class="listview-title mt-1">Tema</div>
        <ul class="listview image-listview text inset no-line">
            <li>
                <div class="item">
                    <div class="in">
                        <div>
                            Modo oscuro
                        </div>
                        <div class="form-check form-switch  ms-2">
                            <input class="form-check-input dark-mode-switch" type="checkbox" id="darkmodeSwitch">
                            <label class="form-check-label" for="darkmodeSwitch"></label>
                        </div>
                    </div>
                </div>
            </li>
            <!-- <li>
                <a class="item" @click="notificationPushTest">
                    <div class="in">
                        <div>Prueba de Notificacion</div>
                        <span class="text-primary">Clic</span>
                    </div>
                </a>
            </li> -->
        </ul>

        <!-- <div class="listview-title mt-1">Notificaciones</div> -->
        <ul class="listview image-listview text inset">
            <!-- <li>
                <div class="item">
                    <div class="in">
                        <div>
                            Alerta de pago
                            <div class="text-muted">
                                Enviar notificación cuando se reciba un nuevo pago
                            </div>
                        </div>
                        <div class="form-check form-switch  ms-2">
                            <input class="form-check-input" type="checkbox" id="SwitchCheckDefault1">
                            <label class="form-check-label" for="SwitchCheckDefault1"></label>
                        </div>
                    </div>
                </div>
            </li> -->
            <!-- <li>
                <a href="#" class="item">
                    <div class="in">
                        <div>Sonido de notificación</div>
                        <span class="text-primary">Beep</span>
                    </div>
                </a>
            </li> -->
        </ul>

        <div class="listview-title mt-1">Configuración del perfil</div>
        <ul class="listview image-listview text inset">
            <!-- <li>
                <a href="#" class="item">
                    <div class="in">
                        <div>Cambiar nombre de usuario</div>
                    </div>
                </a>
            </li> -->
            <li>
                <a href="/settings/mobile" class="item">
                    <div class="in">
                        <div>Actualizar numero movil</div>
                    </div>
                </a>
            </li>
            <!-- <li>
                <a href="#" class="item">
                    <div class="in">
                        <div>Dirección</div>
                        <span class="text-primary">Editar</span>
                    </div>
                </a>
            </li>
            <li>
                <div class="item">
                    <div class="in">
                        <div>
                            Perfil privado
                        </div>
                        <div class="form-check form-switch ms-2">
                            <input class="form-check-input" type="checkbox" id="SwitchCheckDefault2">
                            <label class="form-check-label" for="SwitchCheckDefault2"></label>
                        </div>
                    </div>
                </div>
            </li> -->
        </ul>

        <div class="listview-title mt-1">Seguridad</div>
        <ul class="listview image-listview text mb-2 inset">
            <li>
                <a href="/settings/change-password" class="item">
                    <div class="in">
                        <div>Actualizar contraseña</div>
                    </div>
                </a>
            </li>
            <!-- <li>
                <div class="item">
                    <div class="in">
                        <div>
                            Verificación en dos pasos
                        </div>
                        <div class="form-check form-switch ms-2">
                            <input class="form-check-input" type="checkbox" id="SwitchCheckDefault3" checked />
                            <label class="form-check-label" for="SwitchCheckDefault3"></label>
                        </div>
                    </div>
                </div>
            </li> -->
            <!-- <li>
                <a href="#" class="item">
                    <div class="in">
                        <div>Cerrar sesión en todos los dispositivos</div>
                    </div>
                </a>
            </li> -->
        </ul>


    </div>
    <!-- * Cápsula de la Aplicación -->

    <default-button-menu />
</template>

<script>
export default {
    data() {
        return {
        };
    },
    mounted() {
        let self = this
        self.$root.loadBackButtom();

        
        var pageBody = document.querySelector("body");
        var switchDarkMode = document.querySelectorAll(".dark-mode-switch");

        function switchDarkModeCheck(value) {
            switchDarkMode.forEach(function (el) {
                el.checked = value
            })
        }
        switchDarkMode.forEach(function (el) {
            el.addEventListener("click", function () {
                var darkmodeCheck = localStorage.getItem("FinappDarkmode");
                var bodyCheck = pageBody.classList.contains('dark-mode');
                if (darkmodeCheck === 1 || darkmodeCheck === "1" || bodyCheck) {
                    pageBody.classList.remove("dark-mode");
                    localStorage.setItem("FinappDarkmode", "0");
                    switchDarkModeCheck(false);
                }
                else {
                    pageBody.classList.add("dark-mode")
                    switchDarkModeCheck(true);
                    localStorage.setItem("FinappDarkmode", "1");
                }
            })
        })
    },
    methods: {
        // notificationPushTest() {
        //     let self = this
        //     if (!("Notification" in window)) {
        //         // Check if the browser supports notifications
        //         alert("This browser does not support desktop notification");
        //     } else if (Notification.permission === "granted") {
        //         console.log('granted')
        //         // Check whether notification permissions have already been granted;
        //         // if so, create a notification
        //         const notification = new Notification("Hi there!");
        //         // …
        //     } else if (Notification.permission !== "denied") {
        //         // We need to ask the user for permission
        //         Notification.requestPermission().then((permission) => {
        //         // If the user accepts, let's create a notification
        //         if (permission === "granted") {
        //             const notification = new Notification("Hi there!");
        //             // …
        //         }
        //         });
        //     }

        //     // At last, if the user has denied notifications, and you
        //     // want to be respectful there is no need to bother them anymore.
        // },
    }
}
</script>